var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.207782 2.00235L5.99828 7.79274C6.13209 7.92654 6.31049 8 6.50486 8C6.69531 8 6.87383 7.92654 7.00742 7.79274L12.7925 2.00784C12.9263 1.87393 13 1.69542 13 1.50496C13 1.31451 12.9264 1.13589 12.7925 1.00209L12.3665 0.576044C12.2327 0.442239 12.0541 0.368361 11.8636 0.368361C11.6732 0.368361 11.4946 0.442239 11.3607 0.576044L6.50285 5.43393L1.63958 0.570443C1.50577 0.436744 1.32726 0.362971 1.1367 0.362971C0.946244 0.362971 0.767838 0.436744 0.633927 0.570443L0.207782 0.996696C-0.0693407 1.27392 -0.0693407 1.72512 0.207782 2.00235Z",
    fill: "#A93E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkArrowDown);
export default __webpack_public_path__ + "static/media/pink-arrow-down.a5dc2fd8f5eed5b9ef7f491f1ad3488d.svg";
export { ForwardRef as ReactComponent };